import angular from 'angular';
import booksMenu from '../../menu/Menu';
import chargesReportTemplate from './chargesReport.html';

export default angular
  .module('csm.books.chargesReport', [booksMenu])
  .component('chargesReport', {
    template: chargesReportTemplate,
    controller: chargesController,
    bindings: { showSource: '<' }
  }).name;

/*******************************************************************************
 * chargesController */
/**
 * This provides access to generate a report on credit card charges for In Person
 * and webStore sales.
 *******************************************************************************/
/* @ngInject */ function chargesController(BusyScreen, Session, SERVER) {
  /** Report Request. */
  var $ctrl = this;
  const dbConstants = SERVER.BooksDBConstants;
  $ctrl.req = {
    reportFormat: 'EXCEL',
    source: 'A',
    status: dbConstants.CS_COMPLETED
  };

  $ctrl.reportPage = Session.getSessionURL('/books/ChargesReport.aspx');

  /*----------------------------------------------*/
  /* Static array for the status source dropdown. */
  /*----------------------------------------------*/
  $ctrl.statusSource = [
    { label: 'All', source: 'A' },
    { label: 'Point of Sale', source: 'P' },
    { label: 'Return', source: 'R' },
    { label: 'Web Store', source: 'W' }
  ];

  /**
   * We purposefully left the status for Created and Missing out of the dropdown. A request was made in GR-2248,
   * to remove the status for Created and Missing from appearing on the report as it was causing confusion to our customers.
   *
   * https://graystep.atlassian.net/browse/GR-2248
   */
  $ctrl.statuses = [
    { label: 'All', value: null },
    {
      label: 'Authorized (CNP - KPS)',
      value: dbConstants.CS_AUTHORIZED,
      explanation:
        'The transaction has been marked as pending but not charged yet. (Card Not Present Only) [Webstore/Community Store Payments]'
    }, // KPS CNP only
    {
      label: 'Confirmed',
      value: dbConstants.CS_CONFIRMED,
      explanation:
        'The processor has charged the customer, but a receipt could not be automatically generated.'
    },
    {
      label: 'Completed',
      value: dbConstants.CS_COMPLETED,
      explanation:
        'GrayStep created the receipt and linked the transaction to the receipt.'
    },
    {
      label: 'Cancelled',
      value: dbConstants.CS_CANCELED,
      explanation:
        'The transaction was cancelled by the customer or by an admin before it was completed.'
    },
    {
      label: 'Declined',
      value: dbConstants.CS_DECLINED,
      explanation:
        'The processor declined the transaction. This can be for a variety of reasons, such as insufficient funds or an invalid card.'
    },
    {
      label: 'Voided',
      value: dbConstants.CS_VOIDED,
      explanation:
        'The transaction was voided by GrayStep system after it was charged.'
    },
    {
      label: 'Processor Void Error',
      value: dbConstants.CS_PROCESSOR_VOID_ERROR,
      explanation:
        'The transaction itself went through fine, but voiding it failed at the processor. This transaction needs to be resolved manually.'
    }
  ];

  $ctrl.individualStatuses = $ctrl.statuses.filter(
    (status) => status.value !== null
  );

  BusyScreen.setBusy(false);
}
